"use client"

import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import AuthLayout from './AuthLayout'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')

  const navigate = useNavigate()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setIsLoading(true)

    try {
 
      await new Promise(resolve => setTimeout(resolve, 1000)) 
     
      navigate('/reset-password/code')
    } catch (error) {
      console.error('Password reset error:', error)
      setError('An error occurred while sending reset instructions')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AuthLayout>
      
      <div className="text-center mb-8">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2 font-satoshi">Forgot Password?</h2>
        <p className="text-gray-600 font-satoshi">Reset your password</p>
      </div>

     
      <form onSubmit={handleSubmit} className="space-y-6">
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm font-satoshi">
              {error}
            </div>
          )}

        
          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2 font-satoshi">
              Email Address
            </label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="e.g. johndoe@gmail.com"
              className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-forestGreen-100 focus:border-transparent outline-none transition-colors bg-white font-satoshi"
              required
            />
          </div>

         
          <button
            type="submit"
            disabled={isLoading || !email}
            className={`w-full font-medium py-3 px-4 rounded-lg transition-colors font-satoshi disabled:bg-gray-400 ${
              isLoading
                ? 'bg-gray-400 cursor-not-allowed text-white'
                : 'bg-forestGreen-100 hover:bg-green-700 text-white'
            }`}
          >
            {isLoading ? (
              <div className="flex items-center justify-center">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                Sending...
              </div>
            ) : (
              'Reset Password'
            )}
          </button>

        
          <div className="text-center">
            <Link to="/login" className="text-teal-600 hover:text-teal-700 text-sm font-medium font-satoshi">
              Sign In
            </Link>
          </div>
        </form>
    </AuthLayout>
  )
}

export default ForgotPassword